<template>
  <v-snackbar v-model="vModel" :timeout="-1" color="warning">
    <v-container class="pa-0 ma-0">
      <v-row dense align="center">
        <v-col cols="100%">
          {{ $t("app.snackbar-updated.text") }}
        </v-col>
        <v-col cols="auto" class="pl-5">
          <v-btn @click="onClickUpdate" small color="success" elevation="0">
            {{ $t("app.snackbar-updated.btn-text") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-snackbar>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  props: {
    value: Boolean,
  },
  emits: ["input"],
  setup(props, ctx) {
    const vModel = computed({
      get() {
        return props.value;
      },
      set(val) {
        ctx.emit("input", val);
      },
    });

    const onClickUpdate = async (): Promise<void> => {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
      }
      window.location.reload();
    };
    return {
      vModel,
      onClickUpdate,
    };
  },
});
</script>
